(function (M) {
  if (!M) return;
  var d = document, ty = d.querySelector('.ty');
  if (!ty) return;
  M.tag('.ty-stage.off .logo', 'fade');
  M.tag('.ty-stage.off h2, .ty-stage.off .en2', 'up', { d: 0.1, step: 0.12 });
  M.tag('.ty-stage.off .box', 'rise', { d: 0.3 }).forEach(function (b) { b.classList.add('mo-float'); });
  M.tag('.ty-stage.off .row', 'up', { d: 0.5 });
  var g = d.querySelector('.ty-hero .g');
  if (g) g.setAttribute('data-mo-play', '');
  M.tag('.ty-hero .txt > *', 'up', { d: 0.25, step: 0.12 });
  var hero = d.querySelector('.ty-hero');
  if (hero) {
    var P = M.narrow
      ? [[8, 7, 18, 9], [88, 16, 26, 12], [84, 46, 14, 10]]
      : [[51, 12, 26, 11], [58, 84, 18, 13], [93, 16, 22, 9.5], [88, 76, 36, 14], [46, 58, 14, 10.5], [96, 50, 12, 12]];
    var h = '';
    P.forEach(function (p, i) {
      h += '<i style="--x:' + p[0] + '%;--y:' + p[1] + '%;--s:' + p[2] + 'px;--t:' + p[3] + 's;--dl:-' + (i * 1.7).toFixed(1) + 's"></i>';
    });
    M.add(hero, '<div class="ty-pearls mo-deco" aria-hidden="true">' + h + '</div>');
  }
  M.all('.ty-monde .md img').forEach(function (img, i) {
    var w = d.createElement('span');
    w.className = 'ty-medal';
    img.parentNode.insertBefore(w, img);
    w.appendChild(img);
    w.style.setProperty('--ty-src', 'url("' + (img.currentSrc || img.src) + '")');
    M.tag(w, 'drop', { d: 0.1 + i * 0.25 });
  });
  M.tag('.ty-monde h2, .ty-monde h3, .ty-monde p', 'up', { d: 0.2, step: 0.1 });
  M.tag('.ty-who h2', 'up');
  var lis = M.tag('.ty-who li', 'up', { d: 0.1, step: 0.1 });
  lis.forEach(function (li) {
    M.all('svg circle, svg path', li).forEach(function (s) { s.setAttribute('pathLength', '1'); });
  });
  M.tag('.ty-who .note', 'fade', { d: 0.3 });
  M.tag('.ty-ben > .ty-w > h2', 'up');
  var arc = d.querySelector('.ty-arc');
  if (arc) {
    var bcs = M.all('.bc', arc);
    bcs.forEach(function (b, i) { b.style.setProperty('--ty-i', i); });
    if (M.narrow) {
      bcs.forEach(function (b, i) { M.tag(b, 'zoom', { d: (i % 2) * 0.12 }); });
    } else if ('IntersectionObserver' in window) {
      arc.classList.add('ty-seq');
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { arc.classList.add('ty-go'); io.disconnect(); } });
      }, { threshold: 0.3 });
      io.observe(arc);
    }
    M.tag(M.all('.prod img', arc), 'rise', { d: 0.15 }).forEach(function (im) { im.classList.add('mo-float'); });
  }
  M.tag('.ty-brand .yrs', 'up');
  M.count('.ty-brand .yrs b', '50');
  M.tag('.ty-brand .fac', 'zoom', { d: 0.15 });
  var since = d.querySelector('.ty-brand .since span');
  if (since) since.setAttribute('data-mo-drift', '36');
  M.tag('.ty-brand .since', 'fade');
  M.tag('.ty-brand h2, .ty-brand p, .ty-brand .bdg', 'up', { step: 0.12 });
})(window.FJKMotion);
